"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _useEditableProps = _interopRequireDefault(require("../../hooks/useEditableProps"));

var _StoryblokEditableContext = _interopRequireDefault(require("../StoryblokEditableContext"));

/* eslint-disable no-underscore-dangle */
function StoryblokEditable(props) {
  var content = props.content,
      children = props.children;
  var editableProps = (0, _useEditableProps["default"])(content);
  return _react["default"].createElement(_StoryblokEditableContext["default"].Provider, {
    value: {
      editableProps: editableProps
    }
  }, children);
}

var _default = StoryblokEditable;
exports["default"] = _default;